
export const fitnessTemplateWrapperModal: any = {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 13,
    backdropFilter: 'blur(1px)',
    backgroundColor: '#23212185'
}

export const body: any = {
    position: 'fixed',
    backgroundColor: '#f2f5f8',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 13,
    margin: 0,
    overflow: 'scroll',
}